<template>
  <div class="container mt-5">
    <h2 class="text-center mb-4">Heti nem visszaigazolt fogyás</h2>

    <!-- Show loading message or spinner while waiting for the data -->
    <div v-if="loading" class="text-center">
      <p>Adatok betöltése...</p>
    </div>

    <!-- Filter Section -->
    <div v-if="!loading" class="mb-4">
      <h4>Szűrő beállítások</h4>
      
      <!-- Month filter -->
      <label for="monthFilter">Hónap:</label>
      <select id="monthFilter" v-model="selectedMonth" class="form-control mb-3" @change="applyMonthFilter">
        <option value="">Mind</option>
        <option v-for="n in 12" :key="n" :value="n">{{ monthEnum[n-1] }}</option>
      </select>

      <!-- From-To Date filter -->
      <div class="form-inline">
        <label for="fromDate" class="mr-2">Dátum tartomány (from):</label>
        <input type="date" v-model="fromDate" id="fromDate" class="form-control mr-2" @change="clearMonthFilter">

        <label for="toDate" class="mr-2">Dátum tartomány (to):</label>
        <input type="date" v-model="toDate" id="toDate" class="form-control" @change="clearMonthFilter">
      </div>

    </div>

    <!-- Table to display the data, only shows after data is loaded -->

    <table class="table table-bordered table-striped">
      <thead class="thead-dark">
        <tr>
          <th>Hét</th>
          <th>Időszak</th>
          <th>Összesítve</th>
        </tr>
      </thead>
      <tbody>
        <!-- Loop through the filtered data to create table rows -->
        <tr v-for="entry in filteredData" :key="entry.count_id">
          <td>{{ entry.count_id }}. hét</td>
          <td>{{ getWeekDateRange(entry.count_id) }}</td>
          <td>{{ entry.total_attended_count }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// Import axios
import axios from 'axios';

export default {
  name: 'AttendanceTable',
  data() {
    return {
      attendanceData: [],  // Data to be populated from the backend
      filteredData: [],    // Filtered data based on selected filters
      loading: true,       // Loading state to control when to show the table or the loading message
      currentYear: new Date().getFullYear(), // Dynamically get the current year
      selectedMonth: '',   // Selected month filter
      fromDate: '',        // From date filter
      toDate: '',          // To date filter
      monthEnum : [
        'Január',
        'Február',
        'Március',
        'Április',
        'Május',
        'Június',
        'Július',
        'Augusztus',
        'Szeptember',
        'Oktober',
        'November',
        'December'
      ]
    };
  },
  methods: {
    // Method to fetch data from the backend
    fetchAttendanceData() {
      axios.post(this.$BACKEND_HOST + '/api/getstatistics/noshowweek', {
        year: this.currentYear,
        grp_id: -1 // No group filter needed
      })
        .then(response => {
          this.attendanceData = response.data.value;
          this.filteredData = [...this.attendanceData];  // Initialize filteredData with all fetched data
          console.log(this.filteredData)
        })
        .catch(error => {
          console.error('There was an error fetching the attendance data:', error);
        })
        .finally(() => {
          // Set loading to false once data is fetched or an error occurs
          this.loading = false;
        });
    },

    // Method to calculate the start and end dates of a given week
    getWeekDateRange(weekNumber) {
      const startOfYear = new Date(this.currentYear, 0, 1);
      const dayOfWeek = startOfYear.getDay();
      const daysToAdd = (weekNumber - 1) * 7 - (dayOfWeek === 0 ? 6 : dayOfWeek - 1);

      const startDate = new Date(startOfYear);
      startDate.setDate(startDate.getDate() + daysToAdd);

      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);

      const startDateFormatted = this.formatDate(startDate);
      const endDateFormatted = this.formatDate(endDate);

      return `${startDateFormatted} - ${endDateFormatted}`;
    },

    formatDate(date) {
      if (isNaN(date.getTime())) {
        return 'Invalid Date';
      }
      return date.toLocaleDateString('hu-HU');
    },

    // Method to apply filters
    applyFilters() {
      this.filteredData = this.attendanceData.filter(entry => {
        const weekStartDate = this.getWeekStartDate(entry.count_id);

        const monthMatches = this.selectedMonth ? (weekStartDate.getMonth() + 1 === this.selectedMonth) : true;
        const fromDateMatches = this.fromDate ? (weekStartDate >= new Date(this.fromDate)) : true;
        const toDateMatches = this.toDate ? (weekStartDate <= new Date(this.toDate)) : true;

        return monthMatches && fromDateMatches && toDateMatches;
      });
    },

    getWeekStartDate(weekNumber) {
      const startOfYear = new Date(this.currentYear, 0, 1);
      const dayOfWeek = startOfYear.getDay();
      const daysToAdd = (weekNumber - 1) * 7 - (dayOfWeek === 0 ? 6 : dayOfWeek - 1);
      const startDate = new Date(startOfYear);
      startDate.setDate(startDate.getDate() + daysToAdd);
      return startDate;
    },

    // Reset the from-to date filters when a month is selected
    applyMonthFilter() {
      if (this.selectedMonth) {
        this.fromDate = '';  // Clear from date filter if month is selected
        this.toDate = '';    // Clear to date filter if month is selected
      }
      this.applyFilters(); // Reapply filters
    },

    // Reset the month filter when the from-to dates are changed
    clearMonthFilter() {
      if (this.fromDate || this.toDate) {
        this.selectedMonth = '';  // Clear month filter if From-To dates are set
        this.applyFilters(); // Reapply filters
      }
    },
  },
  mounted() {
    this.fetchAttendanceData();
  }
};
</script>

<style scoped>
/* You can add custom styles here if needed */
</style>
